import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';

export const transformOptions = {};
export const BUTTON_SIZE_PX = 36;
export const GALLERY_IMAGE_ZOOM_FACTOR = 8;

// Position constants
const BASE_TOP_POSITION_REM = 5;
const FLOATING_BUTTON_HEIGHT_WITH_GAP_REM = 4;

export const containerSx: SxProps<Theme> = {
	width: '100%',
	height: '100%',
};

export const BUTTON_STYLE = {
	backgroundColor: '#FFF',
	height: `${BUTTON_SIZE_PX}px`,
};

export const floatingButtonContainerSx: SxProps<Theme> = {
	position: 'absolute',
	left: '1rem',
	top: `${BASE_TOP_POSITION_REM}rem`,
	zIndex: 10,
};

const scaleControllersBaseSx = {
	display: 'flex',
	flexDirection: 'column' as const,
	position: 'absolute' as const,
	left: '1rem',
	gap: '8px',
	width: `${BUTTON_SIZE_PX}px`,
};

const scaleControllersDefaultSx: SxProps<Theme> = {
	...scaleControllersBaseSx,
	top: `${BASE_TOP_POSITION_REM}rem`,
};

const scaleControllersWithOffsetSx: SxProps<Theme> = {
	...scaleControllersBaseSx,
	top: `${BASE_TOP_POSITION_REM + FLOATING_BUTTON_HEIGHT_WITH_GAP_REM}rem`,
};

export const getScaleControllersSx = (offsetForCreateButton: boolean): SxProps<Theme> =>
	offsetForCreateButton ? scaleControllersWithOffsetSx : scaleControllersDefaultSx;

export const floatingButtonSx: SxProps<Theme> = (theme) => ({
	backgroundColor: theme.palette.common.white,
	color: 'text.primary',
	textTransform: 'none',
	boxShadow: 2,
	'&:hover': {
		backgroundColor: theme.palette.grey[50],
	},
	'&.Mui-disabled': {
		backgroundColor: theme.palette.action.disabledBackground,
	},
});
